var map = {
	"./1.svg": 385,
	"./2.svg": 650,
	"./3.svg": 355,
	"./arrow-down.svg": 243,
	"./copy.svg": 247,
	"./icon-telegram.svg": 301,
	"./icon-x.svg": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 450;